<style lang="scss">
div#doc-list-ui .ivu-select-selection .ivu-select-arrow:nth-of-type(1) {
  display: block !important;
}
.demo-upload-list {
  display: flex;
  width: 80px;
  height: 80px;
  text-align: center;
  line-height: 80px;
  border: 1px solid transparent;
  border-radius: 4px;
  overflow: hidden;
  background: #fff;
  position: relative;
  margin: 0 4px 4px 0;
  border: 1px solid #ddd;
  padding: 3px;
}
.demo-upload-list img {
  border-radius: 4px;
  width: 100%;
  height: 100%;
  object-fit: contain;
}
.demo-upload-list-cover {
  display: none;
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  background: rgba(0, 0, 0, 0.6);
}
.demo-upload-list:hover .demo-upload-list-cover {
  display: block;
}
.demo-upload-list-cover i {
  color: #fff;
  font-size: 20px;
  cursor: pointer;
  margin: 0 2px;
}
.upload-img-loader {
  .ivu-spin-main {
    display: flex !important;
    justify-content: center;
    align-items: center;
  }
}
.post-type-input {
  .ivu-input {
    height: 32px;
  }
}
</style>

<style lang="scss" scoped>
.upload-wrapper {
  display: flex;
  flex-wrap: wrap;
}
.poster-info {
  display: flex;
  align-items: center;
}
.user-image {
  height: 60px;
  width: 60px;
  /* background: #d8d8d8; */
  background-repeat: no-repeat;
  background-position: center center;
  background-size: cover;
  -webkit-background-size: cover;
  -moz-background-size: cover;
  -o-background-size: cover;
  background-size: cover;
  margin-right: 20px;
}

.post-to {
  display: flex;
  align-items: center;
  margin-top: 5px;
}

.post-to > p {
  margin-right: 10px;
}

.post-item__header {
  border-bottom: 1px solid #eee;
}

.post-item__body {
  margin-bottom: 10px;
}

.action-buttons {
  z-index: 9;
  position: absolute;
  bottom: 0;
  height: 64px;
  width: 100%;
  border-top: 1px solid #eee;
  padding: 15px;
  background: #fff;
}

.post-item-form-component {
  /* height: 86.7vh; */
  height: 100%;
  background: #fff;
  position: relative;
}

.post-item-container {
  height: 100%;
  position: relative;
}

.action-buttons > button.ivu-btn.ivu-btn-default {
  margin-right: 20px;
}

.action-button__post {
  float: right;
}

.demo-spin-icon-load {
  animation: ani-demo-spin 1s linear infinite;
}
@keyframes ani-demo-spin {
  from {
    transform: rotate(0deg);
  }
  50% {
    transform: rotate(180deg);
  }
  to {
    transform: rotate(360deg);
  }
}
.demo-spin-col {
  height: 100px;
  position: relative;
  border: 1px solid #eee;
}

.images > div {
  /* display: flex;
  align-items: center;
  align-content: center; */
  /* height: 200px; */
  margin-top: 10px;
  /* width: 100%; */
  /* flex-direction: column; */
  /* background: #eee; */
  position: relative;
  display: flex;
  flex-direction: row-reverse;
  /* padding: 10px; */
}

/* .images > div > img{
  height: 100%;
  position: relative;
} */

.images {
  display: flex;
  flex-wrap: wrap;
  width: 100%;
  padding: 10px 0;
}

.image > div {
  margin-top: 10px;
  width: 100%;
  background: #eee;
  position: relative;
}

.image > div > .attachement-image {
  height: 200px;
  margin-right: 5px;
  width: 100%;
}

.images > div > .attachement-image {
  height: 85px;
  margin-right: 15px;
  min-width: 85px;
}

.post-type {
  margin-bottom: 10px;
}

.user-post,
.group-post {
  display: flex;
  flex-direction: row;
  width: 100%;
}

.attachement {
  position: relative;
  height: 120px;
  width: 100%;
  margin-top: 10px;
  margin-bottom: 70px;
}

.attachement-preview {
  height: 120px;
  display: flex;
  width: 100%;
  overflow: hidden;
  align-items: center;
  align-content: center;
  border: 1px solid #eee;
}

.attachement-image {
  height: 100%;
  min-width: 130px;
  background: #d8d8d8;
  border-right: 1px solid #eee;
  background-repeat: no-repeat;
  background-position: center center;
  background-size: cover;
  background-size: cover;
}

.attachement-preview > .attachement-details {
  overflow: hidden;
  padding: 15px;
}

.attachement-details > h3 {
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
}

.attachement-details > p {
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 3;
  -webkit-box-orient: vertical;
}

.add-image {
  height: 85px;
  margin-right: 15px;
  min-width: 85px;
  background: #bdbdbd;
  display: flex;
  align-items: center;
  justify-content: center;
}
.report-type {
  border-bottom: 1px solid #eee;
  width: 100%;
  position: absolute;
  margin-left: -10px;
  padding-left: 10px;
  padding-right: 10px;
}

label.post-visibility-radio {
  font-size: 1.1em;
  text-overflow: ellipsis;
  overflow: hidden;
  white-space: normal;
}

.avatar {
  position: unset;
  width: 50px;
  height: 50px;
  border-radius: 50px;
}
</style>

<style lang="scss">
.report-type > .ivu-select > .ivu-select-selection {
  border: none;
}

.group-post > .ivu-input-wrapper > textarea.ivu-input,
.user-post > .ivu-input-wrapper > textarea.ivu-input {
  // border: none !important;
  // border-radius: 0;
  // border: 0;
  resize: none;
}

.desc-input {
  textarea.ivu-input {
    max-height: 40vh !important;
    min-height: 200px !important;
  }
}
.user-desc-input {
  textarea.ivu-input {
    max-height: 40vh !important;
    min-height: 200px !important;
  }
}
.desc-margin-bottom {
  textarea.ivu-input {
    // margin-bottom: 68px !important;
  }
}
.report-type .ivu-select-selection {
  box-shadow: none;
}
.post-type {
  display: flex;
  width: 100%;
}
.post-type-select {
  width: 100%;
  margin-right: 10px;
  .small {
    margin-bottom: 4px;
    line-height: 25px;
  }
  input {
    height: 36px;
    font-size: 14px;
  }
}
</style>


<template>
  <div class="post-item-form-component" v-if="activeCareplan">
    <div class="post-item-container">
      <div class="post-item__body" style="display:flex;">
        <div
          class="user-post"
          v-if="profileInfo && (activeCareplan.id == profileInfo.careplan_id || activeCareplan.id == profileInfo.private_careplan_id) && isPostDocument"
        >
          <div class="post-type" v-if="activeCareplan.type == 'private_journal'">
            <div class="post-type-select" v-if="isPostDocument">
              <small>Document type :</small>
              <Row :gutter="8">
                <i-col :span="12">
                  <Select
                    id="doc-list-ui"
                    v-model="timelineDocumentType"
                    style="width:100%;margin-right:8px"
                  >
                    <Option
                      v-for="item in docList"
                      :value="item.label"
                      :key="item.id"
                    >{{ item.label }}</Option>
                    <Option value="other">Other</Option>
                  </Select>
                </i-col>
                <i-col :span="12">
                  <Input
                    v-if="timelineDocumentType == 'other'"
                    style="width:100%"
                    class="post-type-input"
                    v-model="timelineDataType"
                  />
                </i-col>
              </Row>
            </div>
          </div>
        </div>

        <div
          class="group-post"
          v-if="profileInfo && (activeCareplan.id != profileInfo.private_careplan_id && activeCareplan.id != profileInfo.careplan_id && activeCareplan.id != groupID.artwork)"
        >
          <div class="poster-info">
            <img :src="profileInfo.avatar" class="avatar" />
            <h2 style="margin-left: 10px;">{{ profileInfo.display_name }}</h2>
          </div>
        </div>
      </div>
      <div>
        <div class="upload-wrapper">
          <div class="demo-upload-list" v-for="(item,k) in uploadList" :key="k">
            <div v-if="item.status == 'finished'">
              <img height="80" width="auto" :src="displayImage(item)" />
              <div class="demo-upload-list-cover">
                <Icon type="ios-trash-outline" @click.native="handleRemove(item)"></Icon>
              </div>
            </div>
            <div v-else-if="item.status == 'pending'">
              <Spin fix></Spin>
            </div>
          </div>
          <div v-show="isReportConcern ? uploadList.length < 1 ? true : false : true">
            <Upload
              ref="upload"
              :show-upload-list="false"
              :default-file-list="uploadList"
              :on-success="handleSuccess"
              :on-progress="onProgress"
              :multiple="!isReportConcern"
              :format="['jpg','jpeg','png']"
              :max-size="10000"
              :on-format-error="handleFormatError"
              :on-exceeded-size="handleMaxSize"
              :before-upload="handleBeforeUpload"
              type="drag"
              accept="image/x-png, image/jpeg, image/jpg"
              name="photo[]"
              :action="uploadUrl"
              style="display: inline-block;width:80px;"
            >
              <div style="width: 80px;height:80px;line-height: 80px;">
                <Icon type="ios-camera" style="color:#ddd;line-height:80px" size="50"></Icon>
              </div>
            </Upload>
          </div>
        </div>
        <Input
          v-model="form.data.text"
          type="textarea"
          :autosize="true"
          class="desc-input"
          :class="postImage.length > 0 ? '' : 'desc-margin-bottom'"
          :placeholder="txtPlaceHolder"
          element-id="group-input"
        />
      </div>
    </div>
    <!-- <PostUpdateModalComponent v-on:emitProceed="onProceed"></PostUpdateModalComponent> -->
  </div>
</template>

<script>
import ModalHolder from "@/components/ModalHolderComponent";
import PostUpdateModalComponent from "@/components/PostUpdateModalComponent";
import Utils from "@/utils.js";
import _ from "lodash";

export default {
  name: "PostItemFormComponent",
  props: {
    postType: {
      type: String,
      default: "statement"
    },
    isAdmin: {
      type: Boolean,
      default: false
    }
  },
  components: {
    PostUpdateModalComponent,
    ModalHolder
  },
  data() {
    return {
      visible: false,
      uploadList: [],
      timelineDataType: null,
      docList: [],
      timelineDocumentType: null,
      reportSelected: "",
      form: {
        ...Cons[0].ACTIVITY,
        data: {
          text: ""
        }
      },
      groupID: Cons[0].GROUP_ID,
      postImage: []
    };
  },
  watch: {
    uploadList(n) {
      let loading = false;
      if (n && n.length > 0) {
        n.forEach(e => {
          if (e.status == "pending") {
            loading = true;
            return;
          } else loading = false;
        });
      } else loading = false;
      this.$emit("isUploadingImages", loading);
    }
  },
  computed: {
    isReportConcern() {
      return this.activeCareplan.type == "report_concern";
    },
    brandInfo() {
      return this.$store.getters["user/brandInfo"];
    },
    showModal: {
      get() {
        return this.$store.state.publicModule.showPostItemModal;
      }
    },
    reportCategory: function() {
      return _.orderBy(
        this.$store.state.user.reportCategory.data.choices,
        ["created_at"],
        ["asc"]
      );
    },
    category: function() {
      var selections;
      var type = this.$route.query.type;
      if (type == "concern") {
        selections = _.orderBy(
          this.$store.state.user.category.concern.data.choices,
          ["order"]
        );
      } else if (type == "suggestion") {
        selections = _.orderBy(
          this.$store.state.user.category.suggestion.data.choices,
          ["order"]
        );
      } else if (type == "story") {
        selections = _.orderBy(
          this.$store.state.user.category.suggestion.data.choices,
          ["order"]
        );
      } else if (type == "hero") {
        selections = _.orderBy(
          this.$store.state.user.category.heroes.data.choices,
          ["order"]
        );
      }
      selections = selections == undefined ? [] : selections;
      if (selections.length > 0) {
        this.reportSelected = selections[0].label;
      }
      return selections;
    },
    profileInfo: {
      get() {
        return this.$store.state.user.info;
      }
    },
    activeCareplan: {
      get() {
        return this.$store.state.feed.activeCareplan;
      }
    },
    postLoader: {
      get() {
        return this.$store.state.feed.isLoadingPostActivity;
      }
    },
    fromDoAction: {
      get() {
        return this.$route.query.type || this.$route.query.action;
      }
    },
    uploadUrl() {
      return process.env.VUE_APP_API + "uploadphoto";
    },
    txtPlaceHolder() {
      return "Write something...";
    },
    isPostDocument() {
      return this.$route.query.is_document;
    }
  },
  mounted() {
    // this.$store.dispatch('user/reportCategory').then(
    //   res=>{
    //     this.reportSelected=this.reportCategory[0].label;
    //   }
    // );
    this.loadDocumentType();
  },
  methods: {
    getTextFromHTML(html) {
      let parsed = new DOMParser().parseFromString(html, "text/html")
      return parsed.children[0].innerText;
    },
    displayImage(v) {
      if (v.response && v.response.uploaded.length > 0)
        return `${process.env.VUE_APP_TEMP}/${v.response.uploaded[0]}`;
      return null;
    },
    onProgress(res, file) {},
    handleRemove(file) {
      const fileList = this.$refs.upload.fileList;
      const uplodFileList = this.uploadList;
      this.$refs.upload.fileList.splice(fileList.indexOf(file), 1);
      this.uploadList.splice(uplodFileList.indexOf(file), 1);
    },
    handleSuccess(res, file) {
      let findIdx = _.findIndex(this.uploadList, item => item.uid === file.uid);
      this.uploadList.splice(findIdx, 1, file);
      // this.uploadList.push(file);
    },
    handleFormatError(file) {
      this.$Notice.warning({
        title: "The file format is incorrect",
        desc:
          "File format of " +
          file.name +
          " is incorrect, please select jpg or png."
      });
    },
    handleMaxSize(file) {
      this.$Notice.warning({
        title: "Exceeding file size limit",
        desc: "File  " + file.name + " is too large, no more than 2M."
      });
    },
    handleBeforeUpload(file) {
      const check = this.uploadList.length < 10;
      if (!check) {
        this.$Notice.warning({
          title: "Up to five pictures can be uploaded."
        });
      }

      file.status = "pending";
      this.uploadList.push(file);

      return check;
    },
    loadDocumentType() {
      this.$store.dispatch("feed/loadDocumentTypes").then(res => {
        this.docList = res;
      });
    },
    openPostSelection(v) {
      this.$store.commit("menu/setPostSelectionPlan", v);
      this.$store.dispatch("menu/getPermittedPlan", null);
      this.$store.commit("menu/setPostSelectionModal", true);
    },
    onProceed(data) {
      if (data != "journal_public" && data != "journal_private") {
        let careplanId = data.id;
        this.$store.commit("menu/setPostSelectionModal", false);
        this.$router.push({
          query: {
            post: careplanId,
            action: "post"
          }
        });

        this.$store.commit("publicModule/setShowPostItemModal", true);
      } else {
        this.$store.commit("menu/setPostSelectionModal", false);
        this.$router.push({
          query: {
            post: this.activeCareplan.id,
            action: "post",
            is_public: data == "journal_public",
            tab: data == "journal_public" ? "timeline" : "team"
          }
        });
        this.$store.commit("publicModule/setShowPostItemModal", true);
      }
    },
    showErrorModal(title, content, callback) {
      this.$Message({
        closable: true,
        title: { content: title },
        icon: "alert",
        message: { content: content },
        buttons: [
          {
            label: "Ok",
            type: "primary",
            hideAfter: true,
            action: () => callback
          }
        ]
      });
    },
    validatePost() {
      if (this.activeCareplan.type == "private_journal") {
        if (this.isPostDocument) {
          if (this.timelineDocumentType == "other") {
            if (_.isEmpty(this.timelineDataType)) {
              this.showErrorModal(
                "Required",
                "Please enter a valid document type",
                {}
              );
              return;
            }
          }
        }
      }

      if (_.isEmpty(this.form.data.text) && this.uploadList.length == 0) {
        this.showErrorModal("Required", "Please provide some content", {});
        return;
      }

      this.postUpdate();
    },
    postUpdate() {
      this.form.recurrence = [Utils.setRrulePostDate(new Date())];
      this.form.data_type = "content";
      this.form.timing = ["now"];
      this.form.title = this.profileInfo.display_name;
      //strip html
      this.form.data.text = this.getTextFromHTML(this.form.data.text)

      // return
      //check if post has image
      if (this.uploadList.length > 1) {
        if (this.isPostDocument) this.fillAttachmentData("document");
        else this.fillAttachmentData("slideshow");
      } else if (this.uploadList.length == 1) {
        if (this.isPostDocument) this.fillAttachmentData("document");
        else this.fillAttachmentData("image");
      } else {
        this.form.type = "statement";
      }

      // if (this.activeCareplan.type == "report_concern") this.form.type = "concern";
      if(this.$route.query.type == 'concern'){
        this.form.type = "concern";
      }
      else if(this.$route.query.type == 'hero'){
        this.form.type = "hero";
      }
      
      this.$store
        .dispatch("feed/postCareplanUpdate", {
          id: this.activeCareplan.id,
          data: this.form
        })
        .then(res => {
          this.clearForm();
          if (
            this.activeCareplan.type == "private_journal" ||
            this.activeCareplan.type === "journal"
          ) {
            if (!_.isEmpty(this.$store.state.resource.groupFeed.list)) {
              this.$store.commit("feed/pushResourceGroupFeed", res.data);
            }
            this.$store.commit("feed/pushUserJournalFeed", res);

            if (this.activeCareplan.type === "journal") {
              this.$store.commit("publicProfile/pushItemToTimeline", res);
              this.showSuccessModal(() => {
                this.$router.replace({
                  query: {
                    ...this.$route.query,
                    tab: "timeline"
                  },
                  path: "/profile/" + this.activeCareplan.creator.id
                });
              });
            } else {
              this.$store.commit(
                "publicProfile/pushItemToPrivateTimeline",
                res
              );
              this.showSuccessModal(() => {
                this.$router.replace({
                  query: {
                    ...this.$route.query,
                    tab: "team"
                  },
                  path: "/profile/" + this.activeCareplan.creator.id
                });
              });
            }
          } else {
            if (!_.isEmpty(this.$store.state.user.feed.list)) {
              this.$store.commit("feed/pushResourceGroupFeed", res.data);
            }

            if (
              this.isAdmin ||
              (this.activeCareplan.post_require_approval == 0 &&
                !_.isEmpty(
                  this.$store.state.resource.groupFeed.list.careplan_item
                ) &&
                this.activeCareplan.type != "report_concern")
            ) {
              if (_.get(this.$route.query, "from") == "organization")
                this.$store.commit("org/pushItemToOrganizationFeed", res);
              else
                this.$store.commit("resource/pushItemToResourceGroupFeed", res);
            }

            if (this.activeCareplan.type == "report_concern") {
              this.showSuccessModal(() => {
                this.$router.go(-1);
              });
            } else if (this.$route.query.from == "organization") {
              this.showSuccessModal(() => {
                this.$router.replace({
                  query: {
                    title: this.$route.query.title || "",
                    t: "post"
                  }
                })
              });
            } else {
              this.showSuccessModal(() => {
                this.$router.push({
                  path: "/resources/" + this.activeCareplan.id
                });
              });
            }
          }

          this.$store.commit("publicModule/setShowPostItemModal", false);
        })
        .catch(err => {
          console.log("POSTING ITEM ERROR", err);

          this.$Message({
            closable: true,
            durationInSec: 3,
            icon: "alert",
            title: { content: "Failed" },
            message: { content: "An error has occured while posting" },
            buttons: [
              {
                label: "Ok",
                type: "primary",
                hideAfter: true,
                action: () => {}
              }
            ]
          });
        });
    },
    showSuccessModal(callback) {
      this.$Message({
        closable: true,
        title: { content: "Success" },
        icon: "alert",
        message: {
          content:
            this.isAdmin || this.activeCareplan.post_require_approval == 0
              ? "Successfully Posted"
              : "Thank you for posting! Your post will not be visible until a moderator has approved it for posting."
        },
        buttons: [
          {
            label: "Ok",
            type: "primary",
            hideAfter: true,
            action: () => callback()
          }
        ]
      });
    },
    clearForm() {
      this.form = {
        data: {
          text: ""
        }
      };
      this.uploadList = [];
    },
    fillAttachmentData(type) {
      this.form.type = "attachment";
      this.form.data["attachment_type"] = type;

      if (type == "slideshow") {
        this.form.data["list"] = [];

        for (let i = 0; i < this.uploadList.length; i++) {
          if (this.uploadList[i].status == "finished") {
            this.form.data.list.push({
              photo: this.uploadList[i].response.uploaded[0],
              description: "",
              title: "",
              video: null,
              order: parseInt(i)
            });
          }
        }
        if (this.uploadList.length > 0) {
          this.form.cover_photo = [
            { day: 0, image: this.uploadList[0].response.uploaded[0] }
          ];
        }
      } else if (type == "image") {
        if (this.uploadList.length > 0) {
          this.form.cover_photo = [
            { day: 0, image: this.uploadList[0].response.uploaded[0] }
          ];
        }
      } else if (type == "document") {
        if (this.timelineDocumentType != "other")
          this.form.data.document_type = this.timelineDocumentType;
        else {
          this.form.data.document_type = this.timelineDataType;
        }

        this.form.data["list"] = [];
        for (let i = 0; i < this.uploadList.length; i++) {
          if (this.uploadList[i].status == "finished") {
            this.form.data.list.push({
              photo: this.uploadList[i].response.uploaded[0],
              description: "",
              title: "",
              video: null,
              order: parseInt(i)
            });
          }
        }
        if (this.uploadList.length > 0) {
          this.form.cover_photo = [
            { day: 0, image: this.uploadList[0].response.uploaded[0] }
          ];
        }
      }
    },
    closeModal() {
      this.timelineDocumentType = null;
      this.timelineDataType = null;
      this.clearForm();
      this.$emit("closeModal");
    }
  }
};
</script>
